'use client';

import '@ui5/webcomponents/dist/StandardListItem.js';
import { ValueState, ListItemType } from '../../enums/index.js';
import { withWebComponent } from '../../internal/withWebComponent.js';
/**
 * The `StandardListItem` represents the simplest type of item for a `StandardListItemst`. This is a list item, providing the most common use cases such as `text`, `image` and `icon`.
 *
 * __Note:__ This component is a web component developed by the UI5 Web Components’ team.
 *
 * [UI5 Web Components Storybook](https://sap.github.io/ui5-webcomponents/playground/?path=/docs/main-List)
 */
const StandardListItem = withWebComponent('ui5-li', ['accessibleName', 'additionalText', 'additionalTextState', 'description', 'icon', 'image', 'type'], ['iconEnd', 'navigated', 'selected'], ['imageContent', 'deleteButton'], ['detail-click']);
StandardListItem.displayName = 'StandardListItem';
StandardListItem.defaultProps = {
  additionalTextState: ValueState.None,
  type: ListItemType.Active
};
export { StandardListItem };